import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  label: string;
  title: string;
  intro?: string;
  children?: ReactNode;
  visual?: ReactNode;
  compact?: boolean;
}
export function PageHero({
  label,
  title,
  intro,
  children,
  visual,
  compact = false
}: PageHeroProps) {
  return <section className="on-dark relative overflow-hidden bg-aubergine text-porcelain" data-id="element-485" data-mp="epvidquji2bo">
      <div className={`mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-12 lg:items-center lg:px-10 ${compact ? 'pb-14 pt-32 lg:pb-16 lg:pt-40' : 'pb-20 pt-36 lg:pb-24 lg:pt-44'}`} data-id="element-486" data-mp="1ccuh074slkc7">
        <motion.div className={visual ? 'lg:col-span-7' : 'lg:col-span-9'} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-487" data-mp="12d3izvh0wn7d">
          <p className="font-serif text-xl italic text-copper-light" data-id="element-488" data-mp="3i5iz228g6kzk">{label}</p>
          <h1 className={`mt-4 font-semibold leading-[1.08] tracking-tight ${compact ? 'text-4xl sm:text-5xl' : 'text-4xl sm:text-5xl lg:text-6xl'}`} data-id="element-489" data-mp="3i7ndhe3z32e3">
            {title}
          </h1>
          {intro && <p className="mt-7 max-w-2xl text-lg leading-relaxed text-porcelain/75" data-id="element-490" data-mp="2j6lx7dv78ebg">{intro}</p>}
          {children && <div className="mt-10 flex flex-wrap gap-4" data-id="element-491" data-mp="2o446j5d4ovjz">{children}</div>}
        </motion.div>
        {visual && <div className="hidden max-w-md justify-self-end lg:col-span-5 lg:block lg:w-full" data-id="element-492" data-mp="2achbf8ux9t2s">{visual}</div>}
      </div>
    </section>;
}